import monitor from "@/utils/monitoring";
import { apiFetch } from "./restApi";
import { YesNo } from "@/types";

export const createAccount = async (args: {
  caseId: string;
  signature: string | null;
  sector?: string;
  record: any;
}) => {
  const { caseId, signature, sector, record } = args;

  const typeObject = !sector ? {} : { type: sector };

  let result;
  try {
    result = await apiFetch({
      path: `/notifier/cases/${caseId}/accounts`,
      search: !signature ? typeObject : { caseId, sig: signature, ...typeObject },
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: { record },
    });
  } catch (error) {
    monitor.logError({
      event: `POST /notifier/cases/{caseId}/accounts`,
      args,
      error,
    });
    throw error;
  }

  return result;
};

export const updateAccount = async (args: {
  caseId: string;
  signature: string | null;
  sector?: string;
  record: any;
}) => {
  const { caseId, signature, sector, record } = args;

  const typeObject = !sector ? {} : { type: sector };

  let result;
  try {
    result = await apiFetch({
      path: `/notifier/cases/${caseId}/accounts/${record.id}`,
      search: !signature ? typeObject : { caseId, sig: signature, ...typeObject },
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: { record },
    });
  } catch (error) {
    monitor.logError({
      event: `PUT /notifier/cases/{caseId}/accounts/{accountId}`,
      args,
      error,
    });
    throw error;
  }

  return result;
};

export const updateAdditionalHelp = async (args: AdditionalHelpServerRecord) => {
  let result;

  try {
    result = await updateAdditionalHelpRequest(args);
  } catch {
    throw new Error("Error; please try again");
  }

  if (result.error) {
    switch (result.error) {
      default:
        throw new Error("Unexpected error; please contact customer support");
    }
  }

  return result.data;
};

type AdditionalHelpServerRecord = {
  caseId: string;
  signature: string | null;
  record: StateRecord;
};

type StateRecord = {
  requestMissingAssetSearch?: YesNo;
  willingToContribute?: boolean;
};

const updateAdditionalHelpRequest = async (args: AdditionalHelpServerRecord) => {
  const { caseId, signature, record } = args;

  let result;
  try {
    result = await apiFetch({
      path: `/notifier/cases/${caseId}/additional-help`,
      search: !signature ? undefined : { caseId, sig: signature },
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: { record },
    });
  } catch (error) {
    monitor.logError({
      event: `PUT /notifier/cases/{caseId}/additional-help`,
      args,
      error,
    });
    throw error;
  }

  return result;
};
